module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="middle">\r\n    <nav class="nav g-pa">\r\n            <div class="nav-imgbox f-fl f-cl">\r\n                <img  class="nav-tit" src="' +
((__t = ( img[0] )) == null ? '' : __t) +
'" alt="">\r\n                <img  class="nav-desc" src="' +
((__t = ( img[1] )) == null ? '' : __t) +
'" alt="">\r\n            </div>\r\n            <span class="nav-phone f-ft_sub f-fr f-cr">客服热线：' +
((__t = ( phone )) == null ? '' : __t) +
'</span>\r\n        </nav>\r\n        <header class="banner g-pr">\r\n            <img class="image-w" src="' +
((__t = ( img[2] )) == null ? '' : __t) +
'" alt="">\r\n            <div class="banner-down u-flex g-pa">\r\n                <div class="banner-down-1">\r\n                    ';
if (location.hostname.indexOf("test") === 0){ ;
__p += '\r\n                        <img class="image-w" src="' +
((__t = ( img[3] )) == null ? '' : __t) +
'" alt="">\r\n                    ';
}else{;
__p += '\r\n                        <img class="image-w" src="' +
((__t = ( img[9] )) == null ? '' : __t) +
'" alt="">\r\n                    ';
};
__p += '\r\n                    <p class="f-tc f-ellipsis">' +
((__t = ( apptxt )) == null ? '' : __t) +
'</p>\r\n                </div>\r\n                <div class="btns">\r\n                    <div class="btn"><img class="image-w" src="' +
((__t = ( img[4] )) == null ? '' : __t) +
'" alt=""></div>\r\n                    <div class="btn"><img class="image-w" src="' +
((__t = ( img[5] )) == null ? '' : __t) +
'" alt=""></div>\r\n                </div>\r\n            </div>\r\n        </header>\r\n        <section class="part1">\r\n            <img class="image-w" src="' +
((__t = ( img[6] )) == null ? '' : __t) +
'" alt="">\r\n        </section>\r\n        <section class="part2">\r\n            <img class="image-w" src="' +
((__t = ( img[7] )) == null ? '' : __t) +
'" alt="">\r\n        </section>\r\n        <section class="part3">\r\n            <img class="image-w" src="' +
((__t = ( img[8] )) == null ? '' : __t) +
'" alt="">\r\n        </section>\r\n        <footer class="ending f-tc">\r\n            <img class="image-w" src="' +
((__t = ( img[10] )) == null ? '' : __t) +
'" alt="">\r\n        </footer>\r\n        </section>';

}
return __p
}